// select2
let withPrefectures = true;
if (withPrefectures) {
  function formatRepoPrefecture(repo) {
    if (repo.loading) {
      return repo.text;
    }
    var markup = "<div class='select2-result-repository clearfix'>" +
      "<div class='select2-result-repository__meta'>" +
      "<div class='select2-result-repository__title'>" + repo.name + ' ' + repo.postal_code + "</div>";
    if (repo.region && repo.department) {
      markup += "<div class='select2-result-repository__description'>" + repo.region + ' > ' + repo.department + "</div>";
    }
    markup += "</div></div>";

    return markup;
  }

  function formatRepoPrefectureSelection(repo) {
    if (repo.name) {
      $.ajax({
        url: '/prefectures/infos',
        type: 'PUT',
        dataType: 'json',
        // data: "_token=" + _token + "&id=" + repo.id
        data: "_token=" + window.Lar_avel.csrfToken + "&id=" + repo.id
      })
        .done(function (data) {
          if (data && data.view) {
            $('#snippet').html(data.view).show();
            $('#list').hide();
          } else {
            $('#snippet').html('').hide();
            $('#list').show();
          }
        });
      return repo.name + ' ' + repo.postal_code;
    } else {
      return repo.text;
    }
  }

  $(() => {
    if ($('#exam_department-select2').length) {
      $('#exam_department-select2').select2({
        language: 'fr',
        ajax: {
          url: "/xhr/prefectures/suggest",
          type: 'GET',
          dataType: 'json',
          delay: 50,
          data: function (params) {
            return {
              _token: window.Lar_avel.csrfToken, // _token,
              q: params.term, // search term
              page: params.page
            };
          },
          processResults: function (data, params) {
            params.page = params.page || 1;
            return {
              results: data.localities.data,
              pagination: {
                more: (params.page * 30) < data.localities.total
              }
            };
          },
          cache: false
        },
        escapeMarkup: function (markup) {
          return markup;
        }, // let our custom formatter work
        minimumInputLength: 1,
        templateResult: formatRepoPrefecture, // omitted for brevity, see the source of this page
        templateSelection: formatRepoPrefectureSelection // omitted for brevity, see the source of this page
      })
        .on("select2:open", function (e) {
          $('.select2-search__field').val($('#address_city').val());
        });
    }
  });
}